export const breakpoints = {
  medium: "40em",
  large: "65em",
}
